namespace Areas.PunchList.Profile {
    "use strict";

    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }


    // select account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#PunchListProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.AccountId = data.accountId;
            formData.AccountName = data.accountName;
            formData.ProjectCCNumber = data.projectCCNumber;

            form.option("formData", formData);

        }
    }

    export function selectAccount() {
        const form: any = $("#PunchListProfileForm").dxForm("instance");
        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }

}